import type { Option } from "@typings/product/item";

export const optionsToVariantName = (
  options: Option[],
  selected: { [optionId: number]: number }
) => {
  let name = "";
  let isFirstOption = true;

  for (const [optionId, optionValueId] of Object.entries(selected)) {
    const option = options.find((o) => o.id === Number(optionId));

    if (!option) continue;

    const optionValue = option.values.find((v) => v.id === Number(optionValueId));

    if (!optionValue) continue;

    name += isFirstOption ? optionValue.name : ` / ${optionValue.name}`;
    isFirstOption = false;
  }

  return name;
};
